module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAkBAMAAACUH2ytAAAAIVBMVEUAAADAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMBpJ9pcAAAACnRSTlMA3aocFvi6j28iD3ONLQAAAENJREFUGNNjYGBhQABDBTiTWWoRnM22apUCQnwVQsJwUEpMXbWqAMbWWrXQAMpkWrVKePAJd4GE4eLCiLhQhAsjxxEAI6UxIIROsrYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/plan/right.png
// module id = mZBO
// module chunks = 1